const Status = {
    NEW: "NEW",
  CONTACTED: "CONTACTED",
  STUDENT: "STUDENT",
  DELETED: "DELETED",
};

export default Status;
